import React from 'react';
import { Heading } from '../heading';
import { Icon, IconName } from '../icons';
import { StyledWarningCard } from './styled';

interface WarningCardProps {
  variant: 'WARNING' | 'INFO';
}

export function WarningCard({
  children,
  variant
}: React.PropsWithChildren<WarningCardProps>): JSX.Element {
  return <StyledWarningCard variant={variant}>{children}</StyledWarningCard>;
}

function Header({ children }: React.PropsWithChildren): JSX.Element {
  return (
    <div>
      <Icon name={IconName.Warning} />
      <Heading variant="h5">{children}</Heading>
    </div>
  );
}

function Message({ children }: React.PropsWithChildren): JSX.Element {
  return <p>{children}</p>;
}

WarningCard.Header = Header;
WarningCard.Message = Message;
